import { AudioBar, Box } from "@aircall/tractor";

import { PlayerCurrentTime } from "../PlayerCurrentTime/PlayerCurrentTime";
import { PlayerDuration } from "../PlayerDuration/PlayerDuration";

import {
  AudioBarGrid,
  getRichAudioBarThumbHeight,
} from "./PlayerAudioBar.styled";
import { RichAudioBarProps } from "./PlayerRichAudioBar.decl";

import { PlayerSpeakersList } from "@/components/PlayerSpeakersList/PlayerSpeakersList";
import { useTrackPlaying } from "@/hooks/useTrackPlaying/useTrackPlaying";

export function PlayerRichAudioBar({ color, speakers }: RichAudioBarProps) {
  const audioBarColor = speakers.size ? "default" : color;
  const thumbHeight = getRichAudioBarThumbHeight(speakers.size);

  const handleOnClick = useTrackPlaying("audio_bar");

  return (
    <AudioBarGrid data-test="rich-audio-bar">
      <PlayerCurrentTime />
      <Box onClick={handleOnClick}>
        <AudioBar color={audioBarColor} height={`${thumbHeight}px`} />
      </Box>
      <PlayerDuration />
      <PlayerSpeakersList speakers={speakers} />
    </AudioBarGrid>
  );
}
